export function convertMbToLabel(mb: number): string {
  if (mb >= 1024) {
    const gb = mb / 1024;
    return `${gb}GB`;
  }
  return `${mb}MB`;
}